import { getAuthenticityToken } from 'Shared/helpers'
import { apiFetch } from './api'
import { mutationStart, mutationSuccess, mutationError } from './reducer'

// Async mutation actions for the member handicap history. Each performs its
// request and dispatches the MUTATION_* transitions, so the component only wires
// events to actions instead of holding fetch logic (REACT-089). failMessage is
// the fallback surfaced when the server sends no message of its own.

const runMutation = (dispatch, request, failMessage, closeAddForm = false) => {
  mutationStart(dispatch)
  return request
    .then(summary => mutationSuccess(dispatch, summary, closeAddForm))
    .catch(e => mutationError(dispatch, (e && e.message) || failMessage))
}

export const addScore = (dispatch, { url, score, failMessage }) =>
  runMutation(dispatch, apiFetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': getAuthenticityToken() },
    body: JSON.stringify({ score }),
  }), failMessage, true)

export const deleteScore = (dispatch, { baseUrl, scoreId, failMessage }) =>
  runMutation(dispatch, apiFetch(`${baseUrl}/handicap_scores/${scoreId}`, {
    method: 'DELETE',
    headers: { 'X-CSRF-Token': getAuthenticityToken() },
  }), failMessage)
